import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const Input = ({
  name, value, isDisabled, onChange, title, isValid
}) => (
  <div className="formProfile-container">
    <label htmlFor={name}>{title}</label>
    {isDisabled
      ? (<input type="text" id={name} value={value} disabled={isDisabled} />)
      : (
        <input className={`${isValid ? 'invalid' : 'valid'}`} type="text" id={name} value={value} onChange={(e) => onChange(name, e)} disabled={isDisabled} />
      )}

  </div>
);

Input.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool,
};

Input.defaultProps = {
  isDisabled: false,
  value: '',
  isValid: false,
};

export default Input;
